import { z } from 'zod';
const MAX_DEFERRED_ORDERS_DAYS = 93;
// The billetterie has no payment-method filter, so every order of the period is read; on a large
// CSE a year takes minutes.
export const cseDeferredOrdersQuerySchema = z
    .object({
    startDate: z.iso.date(),
    endDate: z.iso.date(),
})
    .refine(({ startDate, endDate }) => startDate <= endDate &&
    Date.parse(endDate) - Date.parse(startDate) <= MAX_DEFERRED_ORDERS_DAYS * 86400000, { message: 'Choisissez une période de 3 mois au plus' });
export const attachBilletterieOrderSchema = z.object({
    /** As the billetterie wrote it (« 2026-10-28 10:11:12 »): the order is read back by it. */
    checkoutCompletedAt: z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/),
    cardId: z.number().int().positive(),
});
